import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Hidden from '@material-ui/core/Hidden';
import { layout } from 'styles';

const NavBar = () => {
    const { navBarRouterLink } = layout.makeNavBarRouterLinkStyles();
    const checkoutView = !window.location.href.match('/checkout/confirm') && window.location.href.match('/checkout/[^?]+');
    const productView = window.location.href.match('/products/[^?]+');

    useHistory();

    return (
            <Box component="nav" alignItems="center" display="flex" mt={1}>
                {(checkoutView || productView) && (
                    <Link className={navBarRouterLink} to="/products">
                        wróć do zakupów
                    </Link>
                )}
            </Box>
    );
};

export default NavBar;
